<template>

  <div class="elements-container elements-container_upper">

    <transition name="fade-el">

      <div v-show="state === 'start'" class="start-el start-star start-star_empty"></div>

    </transition>

    <transition name="fade-el">

      <div v-show="state === 'start'" class="start-el start-star start-star"></div>

    </transition>

    <transition name="fade-el">

      <div v-show="state === 'start' || state === 'final'" class="start-el like"></div>

    </transition>

    <transition name="fade-el">

      <div v-show="state === 'start' || state === 'final'" class="start-el dislike"></div>

    </transition>

  </div>


</template>

<script>

export default {

  name: 'ElementsContainerUnder',

  props: ['state']

}

</script>

<style lang="sass" scoped>

.start-el
  position: absolute

.elements-container
  position: absolute
  width: 100%
  height: 100%
  overflow: hidden

  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  pointer-events: none

  position: absolute

.start-star
  width: 195px
  height: 195px
  background-image: url(../assets/img/star_filled.svg)
  z-index: 10
  left: calc(50% - 294px)
  top: calc(50% - 280px)

  &_empty
    background-image: url(../assets/img/star.svg)
    left: calc(50% + 124px)
    top: calc(50%)

.like
  width: 107px
  height: 89px
  left: calc(50% + 205px)
  top: calc(50% - 190px)
  background-image: url(../assets/img/true.svg)

.dislike
  width: 109px
  height: 106.57px
  left: calc(50% - 315px)
  top: calc(50% + 10px)
  background-image: url(../assets/img/false.svg)

@media (max-width: 420px)

  .start-star
    width: 35vw
    height: 35vw
    left: calc(50% - 60vw)
    top: calc(50% - 58vw)

    &_empty
      left: calc(50% + 30vw)
      top: calc(50% + 8vw)

  .like
    width: 17vw
    height: 14vw
    left: calc(50% + 28vw)
    top: calc(50% - 56.5vw)

  .dislike
    width: 17.5vw
    height: 17vw
    left: calc(50% - 46vw)
    top: calc(50% + 55vw)

</style>
